export interface ProcessCreateWorkOrder {
  id: number
  processId: number
  typeProcessId: number
  fileName: string
  mimeType: string
  urlFile: string
  statusId: number | null
  fileNameResulting: string
  mimeTypeResulting: string
  urlFileResulting: string
  createDate: Date | null
  startDate: Date | null
  endDate: Date | null
  urlProcess: string
  data: string
}

export interface ProcessState {
  mensaje: string
  tipoMensaje: string
  switchSnackBar: boolean
  switchModal: boolean
  rows: ProcessCreateWorkOrder[] | undefined
  showModalReportDiff: boolean
  isLoadingGrid: boolean
  isLoadingPrint: boolean
  pickingValidatePDF: string
  page: number
  rowsPerPage: number
  totalItems: number
  isLoadingButton: boolean
  showAlert: boolean
}

export enum EnumTypeProcess {
  CreateWorkOrder = 1,
  CreatePickingRoute = 2,
  CreatePackingList = 3,
  LoadInventory = 4,
  InternalOrder = 5,
  RequestKardex = 6,
  PositionMassive = 7,
  PositionExport = 8,
  MasiveProcessAsnReceive = 9,
  MasiveCreateInventoryCheck = 10,
  MasiveCreateWorkOrderRecall = 11
}

export enum EnumTypeFile {
  File = 1,
  ResultFile = 2
}
